import Alpine from "alpinejs";

interface Settings {
  strokeColor: string;
  strokeWidth: number;
  colors: string[];
  canvasId: string;
  setStrokeColor: (color: string) => void;
  setStrokeWidth: (width: number) => void;
}

Alpine.store("settings", {
  colors: [
    "black",
    "#e81416",
    "#ffa500",
    "#faeb36",
    "#79c314",
    "#487de7",
    "#4b369d",
    "#70369d",
  ],
  strokeColor: "black",
  strokeWidth: 2,
  canvasId: "drawingArea",

  setStrokeColor(color: string) {
    this.strokeColor = color;
  },
  setStrokeWidth(width: number) {
    console.log(width);
    this.strokeWidth = width;
  },
});

export const settings = Alpine.store("settings") as Settings;
Alpine.start();
